// extracted by mini-css-extract-plugin
module.exports =  {"reportHeader":"reportHeader_w_pxyK4l","viewContainer":"viewContainer_uMFbdvKk","withNoSidebar":"withNoSidebar_x9ziyxe8","pagesContainer":"pagesContainer_tdV2_agc"};